import React, { useEffect, useRef } from 'react'

// --- MaterialUI --- //
import * as synthesisType from './synthesisType'
import useTranslate from '../../../../../i18n/useTranslate'
import MyAccordion from '../../../../../control/accordion/accordion'
import Autocomplete from '../../../../../control/autocomplete/autocomplete'
import { FieldArray } from 'react-final-form-arrays'
import ResultConsideration from '../../../shareUI/resultConsideration/resultConsideration'
import { Form, FormSpy } from 'react-final-form'
import arrayMutators from 'final-form-arrays'
import { convertDateToFormatEN, convertDateToFormatTH } from '../../../../../utilities/date'
import useSynthesis from './useSynthesis'
import useCheckPermission from '../../../../../utilities/checkPermission'
import { Grid, makeStyles, Typography } from '@material-ui/core'
import Dialog from '../../../../../control/dialog/dialog'
import PageAction from '../pageAction'
import useSnackbarAction from '../../../../../stores/snackbar/snackbarAction'
import CopyToClipboard from '../../../../../control/copyToClipboard/copyToclipboard'
import DisplayUpdater from '../../../shareUI/displayUpdater/displayUpdater'
import RichTextEditor from '../../../../../control/richTextEditor/richTextEditor'
import { richEditorRequired } from '../../../../../utilities/validate'
import ModeAccordion from '../../../shareUI/modeAccordion/ModeAccordion'
import ExportToMSWord from '../../../../../control/exportToMSWord/exportToMSWord'

const SynthesisREC1View = (props: synthesisType.SynthesisViewType) => {
    const {
        formRef,
        isExempt,
        isViewMode,
        commentList,
        projectData,
        configDialog,
        reviewerList,
        initialValues,
        initialSynthesis,
        commentTitleList,
        isShowUpdateDate,
        isDisplayCopyToClipboard,
        dataSourceForCopyToClipboard,
        useAccordionMode,
        dataSourceForExport,
        resetField,
        confirmField,
        defineValueFromInit,
        editInitialSynthesis,
        updateCommentary,
        onSubmitForm,
        onRefDialog,
        onClickCancel,
        onChangStatus,
        handleDirtyChange,
        onAutoSave,
    } = props
    // const isViewMode = false
    const checkPermission = useCheckPermission()

    const translate = useTranslate()
    const classes = useStyles()
    const isAdmin = checkPermission.isUserAdmin()
    const isDisableReviewer = isViewMode //irb1 จะเปิดให้สามารถเลือกรายชื่อผู้ให้ความเห็นได้
    const irb = projectData?.irb
    const snackbarAction = useSnackbarAction()

    const isRequiredSynthesize = {
        errorMessage: `${translate.get('MESSAGE.M013')}`,
        showAsterisk: true,
        triggedValidate: true,
    }

    const getDisplayCommitteeSaveDate = (itm: any) => {
        return translate.languageStore.currentLanguage === translate.languageKey.th
            ? convertDateToFormatTH(itm.saveCommentDate)
            : convertDateToFormatEN(itm.saveCommentDate)
    }

    const renderCommitteeComment = (itm: any, index: number) => {
        return (
            <>
                <Grid item xl={12}>
                    <label>
                        <strong>{translate.get('LABEL.COMMITTEE_NAME')} :</strong> {itm.director}{' '}
                        <strong>{translate.get('LABEL.COMMITTEE_MEETING_DATE')} :</strong>{' '}
                        {getDisplayCommitteeSaveDate(itm)}{' '}
                        <strong>{translate.get('LABEL.ETHIC_REVIEW_OUTCOME')} :</strong> {itm.approveStatusName}
                    </label>
                </Grid>
                <Grid item xl={12}>
                    <RichTextEditor
                        name={`commentList${commentTitleList[index]?.id}`}
                        disabled={true}
                        initialRichTextEditor={itm.comment ?? { contentText: '', contentHtml: '' }}
                        label={translate.get('LABEL.SYNTHESIS')}
                        placeholder={
                            isExempt
                                ? translate.get('LABEL.SUGGESTION_NOTICE')
                                : translate.languageStore.currentLanguage === translate.languageKey.th
                                ? commentTitleList[index].name_th
                                : commentTitleList[index].name_en
                        }
                        isHideToolbar={true}
                    />
                </Grid>
            </>
        )
    }

    const renderComment = (name: string, index: number, isDisabled: boolean) => {
        return (
            <Grid container item spacing={2}>
                <Grid item xs={12} md={12} lg={12} xl={12}>
                    {commentList &&
                        commentList?.map((itm: any, idx: number) => {
                            const filterArr = itm?.map((item: any) => {
                                if (commentTitleList[index]?.id === item?.topicID || isExempt) {
                                    return renderCommitteeComment(item, index)
                                }
                            })

                            return filterArr
                        })}
                </Grid>

                <Grid item xs={12} md={12} lg={12} xl={12}>
                    <RichTextEditor
                        name={`${name}.synthesisList`}
                        disabled={isDisabled}
                        initialRichTextEditor={initialSynthesis[index].synthesisList}
                        label={translate.get('LABEL.SYNTHESIS')}
                        placeholder={`${translate.get('LABEL.SYNTHESIS')} (${translate.get('LABEL.NO_COMMENT')} )`}
                        required={isRequiredSynthesize}
                        validates={[richEditorRequired(isRequiredSynthesize.errorMessage)]}
                        isHideToolbar={isDisabled}
                        topicID={initialSynthesis[index].id}
                    />
                </Grid>
            </Grid>
        )
    }

    const renderFieldArray = (isDisabled: boolean, useAccordion: boolean) => {
        return (
            <Grid container item>
                <FieldArray name="synthesisInfo">
                    {({ fields }) => {
                        return fields?.map((name, index) => (
                            <Grid item xs={12} key={`${index}.synthesisInfo`}>
                                {useAccordion ? (
                                    <MyAccordion
                                        title={
                                            isExempt
                                                ? translate.get('LABEL.SUGGESTION_NOTICE')
                                                : `${index + 1}. ${
                                                      translate.languageStore.currentLanguage ===
                                                      translate.languageKey.th
                                                          ? commentTitleList[index]?.name_th
                                                          : commentTitleList[index]?.name_en
                                                  }`
                                        }
                                    >
                                        {renderComment(name, index, isDisabled)}
                                    </MyAccordion>
                                ) : (
                                    <>
                                        <pre />
                                        <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                                            {isExempt
                                                ? translate.get('LABEL.SUGGESTION_NOTICE')
                                                : `${index + 1}. ${
                                                      translate.languageStore.currentLanguage ===
                                                      translate.languageKey.th
                                                          ? commentTitleList[index]?.name_th
                                                          : commentTitleList[index]?.name_en
                                                  }`}
                                        </Typography>
                                        {renderComment(name, index, isDisabled)}
                                    </>
                                )}
                            </Grid>
                        ))
                    }}
                </FieldArray>
            </Grid>
        )
    }

    // ---------- autosave ----------
    // เดิมมี 2 ตัวทำงานพร้อมกัน
    //   1) setInterval ทุก 5 นาที ซึ่งไม่ได้เช็ค lastAutoSaveTime เลย
    //   2) debounce 1 นาที ตอนฟอร์มเปลี่ยน
    // อาจจะยิงซ้อนกันได้ และไม่มีอะไรกันไม่ให้ยิงรอบใหม่ทั้งที่รอบก่อนยังไม่เสร็จ
    // รวมให้เหลือทางเข้าเดียวคือ runAutoSave
    const autoSaveTimer = useRef<any>(null)
    const lastAutoSaveTime = useRef<number>(0)
    const mountTime = useRef(Date.now())
    const isAutoSavingRef = useRef(false)

    const runAutoSave = async (values: any) => {
        if (!values) return
        // กันยิงซ้อนตอนรอบก่อนหน้ายังไม่เสร็จ
        if (isAutoSavingRef.current) return

        const now = Date.now()
        // ไม่ autosave ใน 1 นาทีแรกหลังเปิดหน้า
        if (now - mountTime.current < 60 * 1000) return
        // เว้นระยะอย่างน้อย 1 นาทีจากรอบที่แล้ว
        if (now - lastAutoSaveTime.current < 60 * 1000) return

        isAutoSavingRef.current = true
        lastAutoSaveTime.current = now
        try {
            await onAutoSave(values)
        } finally {
            isAutoSavingRef.current = false
        }
    }

    useEffect(() => {
        mountTime.current = Date.now()
        lastAutoSaveTime.current = 0

        return () => {
            if (autoSaveTimer.current) {
                clearTimeout(autoSaveTimer.current)
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAutoSave = (values: any) => {
        if (!values) return

        if (autoSaveTimer.current) {
            clearTimeout(autoSaveTimer.current)
        }

        autoSaveTimer.current = setTimeout(() => {
            const latestValues = formRef.current?.getState?.()?.values ?? values
            runAutoSave(latestValues)
        }, 60 * 1000)
    }
    

    return (
        <>
            {isDisplayCopyToClipboard && (
                <Grid container spacing={2} xs={12} justify={'flex-end'} className={classes.btnGroup}>
                    <ExportToMSWord dataSource={dataSourceForExport} irb={Number(irb)} />
                    <CopyToClipboard dataSource={dataSourceForCopyToClipboard} pageType={'2'} />
                </Grid>
            )}
            <Form
                onSubmit={onSubmitForm}
                initialValues={{ ...initialValues, synthesisInfo: initialSynthesis }}
                keepDirtyOnReinitialize={true}
                mutators={{
                    ...arrayMutators,
                }}
            >
                {(props) => {
                    const { form, handleSubmit, dirty, invalid, errors } = props
                    formRef.current = form
                    // formRenderPropsRef.current = props
                    return (
                        <Grid container spacing={2}>
                            {isAdmin && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <MyAccordion title={translate.get('LABEL.SYNTHESIS_REVIEWER')}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12} md={12} lg={12} xl={12}>
                                                <Autocomplete
                                                    name="reviewer"
                                                    materialInputProps={{
                                                        label: translate.get('LABEL.REVIEWER_NAME'),
                                                        placeholder: translate.get('LABEL.PLEASE_SELECT'),
                                                        disabled: isDisableReviewer,
                                                    }}
                                                    options={reviewerList}
                                                    required
                                                />
                                            </Grid>
                                        </Grid>
                                    </MyAccordion>
                                </Grid>
                            )}

                            <Grid item xs={12} md={12} lg={12}>
                                {useAccordionMode ? (
                                    <ModeAccordion
                                        noPadding
                                        title={translate.get('LABEL.COMMITTEE_COMMENT')}
                                        isViewMode={true}
                                        renderEditComponent={() => renderFieldArray(false, true)}
                                        renderViewComponent={() => renderFieldArray(true, true)}
                                        fieldNames={['synthesisInfo']}
                                        onCancel={() => {
                                            resetField('synthesisInfo', (data: any) => {
                                                editInitialSynthesis(data)
                                            })
                                        }}
                                        onConfirm={() => {
                                            confirmField('synthesisInfo', (data: any) => {
                                                editInitialSynthesis(data)
                                            })
                                            return updateCommentary('synthesisInfo')
                                        }}
                                        onClickEdit={() => defineValueFromInit('synthesisInfo')}
                                    />
                                ) : (
                                    renderFieldArray(isViewMode, true)
                                )}
                            </Grid>

                            <Grid item xs={12} md={12} lg={12}>
                                <ResultConsideration
                                    irb={irb}
                                    disabled={isViewMode}
                                    onChangStatus={onChangStatus}
                                    isCommitee={0}
                                />
                            </Grid>

                            {isShowUpdateDate && <DisplayUpdater />}
                            {!isViewMode && (
                                <Grid item xs={12} md={12} lg={12}>
                                    <PageAction
                                        onClickClose={() => {
                                            onClickCancel(dirty)
                                        }}
                                        onClickSave={() => {
                                            form.change('submitType', 'save')
                                            handleSubmit()
                                            invalid &&
                                                errors &&
                                                snackbarAction.openSnackbar({
                                                    message: translate.get('MESSAGE.M012'),
                                                    type: 'error',
                                                })
                                        }}
                                        onClickSaveDraft={() => {
                                            form.change('submitType', 'draft')
                                            handleSubmit()
                                        }}
                                    />
                                </Grid>
                            )}

                            <FormSpy subscription={{ values: true, dirty: true }} onChange={(state) => {
                                                                                handleDirtyChange(state)
                                                                                handleAutoSave(state.values)
                                                                            }} />
                            <Dialog onRef={onRefDialog} {...configDialog} />
                        </Grid>
                    )
                }}
            </Form>
        </>
    )
}

const SynthesisREC1: React.FC<synthesisType.SynthesisType> = (props) => {
    const useSyntheticModel = useSynthesis(props)
    return <SynthesisREC1View {...useSyntheticModel} {...props} />
}

const useStyles = makeStyles((theme) => ({
    spacingButton: {
        marginBottom: '10px',
    },
    paper: {
        width: '100%',
        height: 128,
        padding: 20,
    },
    titleFont: {
        color: '#BDBDBD',
    },
    contentFont: {
        fontWeight: 'bold',
    },
    btnGroup: {
        padding: '18px',
    },
}))

export default SynthesisREC1
